import { useState } from "react";
import Chart from "react-apexcharts";
import "./DashboardBalanceLine.css";

const DashboardBalanceLine = () => {
  const [date, setDate] = useState("Today");
  const [showDate, setShowDate] = useState(false);
  const chooseDropdown = (e) => {
    setDate(e.target.value);
    setShowDate((showDate) => !showDate);
  };
  const [options] = useState({
    chart: {
      height: 350,
      type: "line",
      zoom: false,
      toolbar: {
        show: false,
      },
      events: {
        dataPointMouseEnter: function (event) {
          event.path[0].style.cursor = "pointer";
        },
      },
      fontFamily: "poppins",
    },

    dataLabels: {
      enabled: false,
    },
    colors: ["#077aff"],

    stroke: {
      // colors: ["#FF6C40"],
      colors: ["#077aff"],

      curve: "smooth",
      width: 4,
    },
    title: {
      text: "Daily Usage",
      margin: 0,
      floating: true,
      offsetY: 2,
      style: {
        color: document.querySelector("body").classList.contains("dark-mode")
          ? "#ffffff"
          : "#000000",
        fontSize: "20px",
        fontWeight: 600,
      },
    },
    xaxis: {
      labels: {
        style: {
          fontSize: "10px",
          colors: [
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
          ],
        },
        formatter: function (value) {
          return value.toFixed(0) + "h";
        },
        show: true,
      },
      // range: 10,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    markers: {
      size: 0,
      // colors: "#FFE700",
      colors: ["#077aff"],
      strokeColors: "#fff",
      strokeWidth: 3,
      strokeOpacity: 1,
      radius: 2,
      hover: {
        size: 4,
      },
    },
    yaxis: {
      min: 0,
      tickAmount: 6,
      max: 60,
      labels: {
        formatter: function (value) {
          return value.toFixed(0) + "m";
        },
        show: true,
        style: {
          fontSize: "10px",
          colors: [
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
            "#757679",
          ],
        },
      },
    },
    grid: {
      padding: {
        top: 50,
        right: 0,
        bottom: -10,
        left: 20,
      },
      show: false, // you can either change hear to disable all grids
    },

    legend: {
      show: false,
      horizontalAlign: "right",
      position: "top",
      fontFamily: "poppins",
      labels: {
        colors: "#757679",
      },
      offsetY: -5,
      markers: {
        radius: 20,
        fillColors: ["#077aff"],
      },
      itemMargin: {
        // horizontal: 23,
        vertical: 0,
      },
    },
    responsive: [
      {
        breakpoint: 900,
        options: {
          legend: {
            show: false,
          },
        },
      },
    ],
  });
  const [series] = useState([
    {
      name: "Usage",
      data: [
        35, 51, 49, 60, 50, 41, 35, 20, 12, 55, 51, 30, 44, 50, 12, 34, 14, 12,
        50, 30, 50, 35, 51, 49,
      ],
    },
  ]);
  return (
    <div className="dashboardBalanceLine">
      <div className="dashboardBalanceLine__balance flex-row">
        <div className="dashboardBalanceLine__dropdown">
          <div
            className={`dropdown-container flex-row ${showDate && "expand"}`}
            onClick={() => setShowDate((showDate) => !showDate)}
          >
            <p>{date}</p>
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 4L8 12L16 20"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`dropdown-item-container flex-column ${
              showDate && "expand"
            }`}
          >
            <label htmlFor="usage-today">
              <input
                type="radio"
                name="date"
                id="usage-today"
                value="Today"
                onChange={chooseDropdown}
              />
              Today
            </label>
            <label htmlFor="usage-yesterday">
              <input
                type="radio"
                name="date"
                id="usage-yesterday"
                value="Yesterday"
                onChange={chooseDropdown}
              />
              Yesterday
            </label>
            <label htmlFor="usage-three-ago">
              <input
                type="radio"
                name="date"
                id="usage-three-ago"
                value="3 days ago"
                onChange={chooseDropdown}
              />
              3 days ago
            </label>
            <label htmlFor="usage-four-ago">
              <input
                type="radio"
                name="date"
                id="usage-four-ago"
                value="4 days ago"
                onChange={chooseDropdown}
              />
              4 days ago
            </label>
            <label htmlFor="usage-five-ago">
              <input
                type="radio"
                name="date"
                id="usage-five-ago"
                value="5 days ago"
                onChange={chooseDropdown}
              />
              5 days ago
            </label>
            <label htmlFor="usage-six-ago">
              <input
                type="radio"
                name="date"
                id="usage-six-ago"
                value="6 days ago"
                onChange={chooseDropdown}
              />
              6 days ago
            </label>
            <label htmlFor="usage-seven-ago">
              <input
                type="radio"
                name="date"
                id="usage-seven-ago"
                value="7 days ago"
                onChange={chooseDropdown}
              />
              7 days ago
            </label>
          </div>
        </div>
        <div className="dashboardBalanceLine__indicator up flex-row">
          <div className="dashboardBalanceLine__itemIndicator"></div>
          <span className="dashboardBalanceLine__itemPercent">86%</span>
        </div>
      </div>
      <Chart
        options={options}
        series={series}
        type="line"
        // height={90}
        height="400"
        // width="600"
        width={"100%"}
      />
    </div>
  );
};

export default DashboardBalanceLine;
